import Marquee from "react-fast-marquee";

export const DividerMarquee = () => (
  <div
    data-testid="marquee-divider"
    className="glass-panel relative border-x-0 py-8"
  >
    <Marquee speed={28} gradient={false} autoFill>
      {Array.from({ length: 4 }).map((_, i) => (
        <div key={i} className="flex items-center">
          <span className="font-display text-4xl font-800 uppercase tracking-tighter text-outline sm:text-6xl">
            L'évolution de votre intelligence numérique
          </span>
          <span className="mx-8 text-blue-400 sm:mx-14">✦</span>
        </div>
      ))}
    </Marquee>
  </div>
);
